module.exports = __webpack_public_path__ + "static/img/text_logo.f698b19f.svg";